import {ChangeDetectionStrategy, Component} from "@angular/core";
import {environment} from "../../../../../environments/environment";


@Component({
  selector: 'app-hotel-tour-skeleton',
  templateUrl: environment.mobile ? './hotel-tour-skeleton.component.mobile.html' : './hotel-tour-skeleton.component.html',
  styleUrls: environment.mobile ? ['./hotel-tour-skeleton.component.mobile.scss'] : ['./hotel-tour-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HotelTourSkeletonComponent {}
